/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: ITAT Time
==========================================================================================*/

import axios from '../axios.js'
import router from '../router.js'
import { getDefaultScreenPath } from '../utils/defaultScreen.js'
const moment = require('moment') // require
import jwtDecode from 'jwt-decode'
const VueCookie = require('vue-cookie')
import Vue from 'vue'
const client = require("jsreport-client")("http://localhost:5488", "admin", "mypassword")
const fs = require("fs");


const cookie = {
  domain: process.env.VUE_APP_COOKIE_DOMAIN,
  secure: process.env.VUE_APP_COOKIE_SECURE.toLowerCase() == "true",
  path: '/',
  expires: 365
}


const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo ({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },

  async ActionPostContactForm({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('ticket',
      payload)
        .then(response => {
          console.log('post mail', response)
          resolve(response)
        })
        .catch(error => {
          console.log('this is an error')
          console.log(error)
          reject(error)
        }).finally(() => {
          console.log('finally')
        })
    })
  },

  //Authentication

  async ActionAutoSignIn ({ state, commit, dispatch }, isRefresh) {

    console.log('auto sign in')
    // if(process.env.VUE_APP_ENVIRONMENT != 'prod')
    //   return

    try {
      const loggedInResponse = await axios.get(`isloggedon`)
      console.log('logged in response', loggedInResponse)
      if (loggedInResponse.data && loggedInResponse.data.data && loggedInResponse.data.data.isSimulation != null) {
        commit('SetIsSimulation', loggedInResponse.data.data.isSimulation)
      }

      
      // var expiration = session.getAccessToken().getExpiration()
      // console.log("Session expires at : " + expiration)
      // var t = moment.unix(expiration).toDate() - (new Date()).getTime()
      // console.log(t / 1000 / 60 + " minutes remaining")

      // setTimeout(function(){
      //   console.log("Refreshing")
      //   dispatch("ActionAutoSignIn", true)
      // }, t + 1000)

      if (!isRefresh) {
        dispatch('ActionFetchWorkerList')
        const path = router.currentRoute.path
        if (path === '/' || path === '') {
          router.push(getDefaultScreenPath())
        }
      }
      
    } catch (e) {
      console.error(e)
      router.push('/')
      
    }


  },


  ActionFetchWorkerList ({state, commit}, payload) {

    console.log('axios', axios.defaults)

    return new Promise((resolve, reject) => {
      axios.get('Workers')
        .then(response => {
          for (let i = 0; i < response.data.length; i++) {
            const w = response.data[i]
            if (w.WorkerAvatar != null && w.WorkerAvatar.data != null) {
              w.WorkerAvatar = `data:image/jpeg;base64,${Buffer.from(w.WorkerAvatar.data, 'binary').toString('base64')}`
            }
          }
          commit('SetWorkerList', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
            
        })

    })
  },

  ActionSyncWorkerWithJira ({state, commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.put('workers/jira', payload)
        .then(response => {
          commit('ConnectWorkerToJira', payload)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  ActionFetchUserClient ({state, commit}, payload) {
    return new Promise((resolve, reject) => {

      axios.get('account/workerprofile')
        .then(response => {

          if (response.data.User.WorkerType == 2) {
            window.location.href = process.env.VUE_APP_ID_UI
        }

          if (response.data.User.WorkerAvatar != null) {
            if (response.data.User.WorkerAvatar.data != null) {
              const avatarData = response.data.User.WorkerID == -2 ? (`data:image/jpeg;base64,${  response.data.User.WorkerAvatar.data}`) : (`data:image/jpeg;base64,${  Buffer.from(response.data.User.WorkerAvatar.data, 'binary').toString('base64')}`)
              commit('SetUserProfileImage', avatarData)
            }
          }
          commit('SetUserLoggedInStatus', true)
          commit('UPDATE_USER_INFO', {'displayName': response.data.User.WorkerName})
          this.commit('SetIsAdmin', response.data.User.IsAdmin)
          this.commit('SetWorkerID', response.data.User.WorkerID)
          this.commit('SetAuthWorkerID', response.data.AuthUser.WorkerID)
          this.commit('SetIsEveryone', response.data.IsEveryone)
          this.commit('SetJiraDomain', response.data.JiraDomain)
          this.commit('SetDevOpsPAT', response.data.User.DevOpsPAT)
          if (response.data.User.WorkerType == 2) {
            console.log('Is Client')
            this.commit('SetIsClient', true)
          } else {
            this.commit('SetIsClient', false)
            this.dispatch('ActionFetchGlobalData')
          }

          resolve(response)
            
        })
        .catch(error => {
          console.log(error)
          if (error.response && error.response.status === 401) {
            router.push('/unauthorized')
          }
          reject(error)
        })
    })
  },

  ActionLogout ({state}) {
    router.push('/unauthorized')

    // console.log('logout')
    // const accessToken = state.tokens.accessToken
    // router.push('/')

    // console.log('Not doing anything')

    // return new Promise( (resolve,reject) => {

    //     axios.post("account/logout", null, {headers : headers})
    //     .then(response => {
            
    //       resolve(response)
    //     })
    //     .catch(error => {
    //       console.log(error)
    //       this.dispatch("ActionCheckError", error)
    //       reject(error)
    //     })
    // });
  },

  ActionFetchTaskStatusIDLookups ({state, commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get('lookups/TaskStatusID')
        .then(response => {
          commit('SetTaskStatusLookups', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  

  ActionFetchSOWStatusIDLookups ({state, commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get('lookups/SOWStatusID')
        .then(response => {
          commit('SetSOWStatusLookups', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionFetchSOWOverageStatusIDLookups ({state, commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get('lookups/SOWOverageStatusID')
        .then(response => {
          commit('SetSOWOverageStatusLookups', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },
  

  ActionFetchWorkerMessages ({state, commit}) {

    return new Promise((resolve, reject) => {

      axios.get('account/workermessages')
        .then(response => {
            
          commit('SetWorkerMessages', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionDeleteWorkerMessage ({state, commit}, payload) {
 
    return new Promise((resolve, reject) => {

      axios.delete(`account/workermessages/${  payload}`)
        .then(response => {
           
            resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionFetchStatsHours ({state, commit}, payload) {
 
      
    return new Promise((resolve, reject) => {
      console.log(payload)
      axios.get(`stats/statshours?startDate=${payload.startDate  }&endDate=${  payload.endDate}`)
        .then(response => {
          const data = response.data
          commit('SetStatsHours', data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionFetchHoursWorkedDaily ({state, commit}, payload) {

       
    return new Promise((resolve, reject) => {

      axios.get(`Stats/dailyworked/${payload}`)
        .then(response => {
          const data = response.data
          commit('SetRawTotalHoursWorked', data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionFetchBillableHoursWorkedWeekly ({state, commit}, payload) {
       
    return new Promise((resolve, reject) => {

      axios.get(`Stats/BillableWeeklyWorked/${payload}`)
        .then(response => {
          const data = response.data[0]
          commit('SetBillableWeeklyWorked', data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionFetchHoursWorkedWeekly ({state, commit}, payload) {
       
    return new Promise((resolve, reject) => {

      axios.get(`Stats/WeeklyWorked/${payload}`)
        .then(response => {
          const data = response.data
          commit('SetRawTotalHoursWorkedWeekly', data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionFetchGlobalData ({state, commit}, payload) {
    if (state.receivedGlobalData === true && !(payload && payload.forceRefresh)) {
      return Promise.resolve()
    }
    return new Promise((resolve, reject) => {
      axios.get('Clients')
        .then(response => {
          for (let i = 0; i < response.data.length; i++) {
            const c = response.data[i]
            if (c.ClientAvatar != null && c.ClientAvatar.data != null) {
              c.ClientAvatar = `data:image/jpeg;base64,${Buffer.from(c.ClientAvatar.data, 'binary').toString('base64')}`
            }
          }
          commit('SetClientList', response.data)
          commit('SetReceivedGlobalData', true)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  ActionUpdateClientBranding ({dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.post('clients/branding', payload, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(response => {
          dispatch('ActionFetchGlobalData', { forceRefresh: true })
            .then(() => {
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
        })
        .catch(error => {
          console.log(error)
          dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionCreateJiraProjectCategory ({state, commit}, payload) {
    return Promise.resolve()
  },
  ActionDeleteJiraProjectCategory ({state, commit}, payload) {
    return Promise.resolve()
  },


  // /////////////////////////////////////////////
  // Time Entries
  // /////////////////////////////////////////////

 
  ActionSetTimeEntryPrompt ({commit}, payload) {
    commit('SetTimeEntryPrompt', payload)
  },

  ActionFetchMonthlyTable ({state, commit}, payload) {
 
    return new Promise((resolve, reject) => {

      axios.get('Categories/Monthly')
        .then(response => {
          //console.log("Monthly Table", response.data)
          const monthlyTable = []
          for (let i = 0; i < response.data.length; i++) {
            const d = response.data[i]
            const tableEntry = {}
            tableEntry.CategoryName = d.CategoryName
            tableEntry.CategoryTotal = d.CategoryTotal
            tableEntry.MonthHours = []
            tableEntry.MonthHours.push(Math.round(d.CurrentMonthMinus1))
            tableEntry.MonthHours.push(Math.round(d.CurrentMonthMinus2))
            tableEntry.MonthHours.push(Math.round(d.CurrentMonthMinus3))
            tableEntry.MonthHours.push(Math.round(d.CurrentMonthMinus4))
            tableEntry.MonthHours.push(Math.round(d.CurrentMonthMinus5))
            tableEntry.MonthHours.push(Math.round(d.CurrentMonthMinus6))
            tableEntry.MonthHours.push(Math.round(d.CurrentMonthMinus7))
            tableEntry.MonthHours.push(Math.round(d.CurrentMonthMinus8))
            tableEntry.MonthHours.push(Math.round(d.CurrentMonthMinus9))
            tableEntry.MonthHours.push(Math.round(d.CurrentMonthMinus10))
            tableEntry.MonthHours.push(Math.round(d.CurrentMonthMinus11))
            tableEntry.MonthHours.push(Math.round(d.CurrentMonthMinus12))

            monthlyTable.push(tableEntry)
          }
          this.commit('SetMonthlyTable', monthlyTable)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },
  ActionFetchMonthlyChart ({state, commit}, payload) {
    return new Promise((resolve, reject) => {
         

      axios.get('Categories/Quarterly')
        .then(response => {
          const entries = response.data

          const qData = []

          for (let i = 0; i < entries.length; i++) {
            var entry = entries[i]
            let quarter = qData.find(x => x.WorkYear == entry.WorkYear && x.WorkQuarter == entry.WorkQuarter)

            if (quarter == null) {
              qData.push({
                'WorkYear'    : entry.WorkYear,
                'WorkQuarter' : entry.WorkQuarter,
                'Title'       : `${entry.WorkYear  } Q${  entry.WorkQuarter}`,
                'ID'          : qData.length,
                'Categories'  : [],
                'Hours'       : []
              })
              quarter = qData[qData.length - 1]
            }
              
            quarter.Categories.push(entry.CategoryName)
            quarter.Hours.push(Math.round(entry.HoursWorked))

          }

          this.commit('SetQuarterlyData', qData)
          resolve(response)

        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },


  ActionFetchCategories ({state, commit}, payload) {
       

    return new Promise((resolve, reject) => {

      axios.get('Categories/All')
        .then(response => {
          commit('SetCategoryList', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionSaveCategory({state, commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {

      axios.post('Categories', payload)
        .then((response) => {
          // await dispatch('ActionFetchCategories')
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionDeleteCategory({state, commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {

      axios.delete(`Categories?CategoryID=${payload}`)
        .then(response => {
          dispatch('ActionFetchCategories')
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },


  ActionGetCategoryFromSOW ({state, commit}, payload) {
       
    return new Promise((resolve, reject) => {

      axios.get(`Categories/from-sow?ClientID=${payload.ClientID}&EpicName=${payload.EpicName}`)
        .then(response => {
          commit('SetCategoryListSOW', response.data)
          resolve(response.data)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionFetchTimeEntry ({state, commit}, payload) {

     
    return new Promise((resolve, reject) => {

      axios.get(`TimeEntries/${  payload}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionFetchWorkerCurrentTimeEntry ({state, commit}, payload) {
    return new Promise((resolve, reject) => {

      axios.get('workers/CurrentTimeEntry?WorkerID=' + payload)
        .then(response => {
          commit("SetPotentialExternalTask", response.data.task)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionSaveExternalTask ({state, commit}, payload) {
    return new Promise((resolve, reject) => {

      var body = {
        JiraID: state.potentialExternalTask.JiraInfo.id,
        ITATID: state.potentialExternalTask.ITATInfo.TaskID
      }

      axios.post('workers/externalTask', body)
        .then(response => {
          commit("SetPotentialExternalTask", null)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },


  ActionFetchTimeEntries ({state, commit}) {
      
    return new Promise((resolve, reject) => {

      axios.get('TimeEntries')
        .then(response => {
            
          const responses = []

          commit('SetCurrentTimeEntry', null)
          commit ('SetSubTimeEntry', null)
          let alreadySetCurrentTimeEntry = false
          for (let i = 0; i < response.data.length; i++) {
              
            response.data[i]['id'] = i
            //Is a current time entry
            const isCurrentTimeEntry = response.data[i]['TimeOut'] == null
            if (isCurrentTimeEntry) {
              if(!alreadySetCurrentTimeEntry){
                alreadySetCurrentTimeEntry = true
                console.log("Set current time entry")
                commit('SetCurrentTimeEntry', response.data[i])
              }else{
                console.log("Set sub time entry")
                commit('SetSubTimeEntry', response.data[i])
              }
            } else { //Is full time entry
                
              responses.push(response.data[i])
            }
          }
          commit('SetTimeEntryList', responses)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionDeleteTimeEntry ({state, commit, dispatch }, payload) {
       

    return new Promise((resolve, reject) => {

      axios.delete(`TimeEntries/${  payload.RecordID}`)
        .then(response => {
          commit('SetTimeEntryRemoved', payload)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })

    })
  },


  ActionPutTimeEntry ({state, commit, dispatch}, payload) {
       
    return new Promise((resolve, reject) => {

      axios.put(`TimeEntries/${  payload.RecordID}`, payload)
        .then(response => {
          commit('SetTimeEntry', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })

    })
  },

  ActionSetNewTimeEntry ({commit}, payload) {
    commit('SetNewTimeEntry', payload)
  },

  ActionPostTimeEntry ({state, commit, dispatch }, payload) {
    console.log("Post time entry", payload)
    return new Promise((resolve, reject) => {

      axios.post('TimeEntries', payload)
        .then(response => {
          if (response.data.TimeOut == null) {
            console.log('Setting current time entry')
            if(state.currentTimeEntry == null) {
              commit('SetCurrentTimeEntry', response.data)
            }else {
              console.log("Setting sub time entry")
              commit("SetSubTimeEntry", response.data)
            }
          } else {
            commit('SetNewTimeEntry', response.data)
          }
          resolve(response)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })

    })
  },
  

  ActionSetModalData ({commit}, payload) {
    commit('SetModalData', payload)
  },

  ActionOpenCloseModal ({commit}, payload, payload2) {
    commit('SetOpenCloseModal', payload)
  },

  ActionSetLoading ({commit}, payload) {
    if (payload == true) {
      console.log('Loading - True')
    } else {
      console.log('Loading - False')
    }
  },

  ActionCheckError ({context, dispatch}, error) {
    console.log('ACTION ERROR', error)
    dispatch('ActionSetLoading', false)
    dispatch('ActionOpenCloseModal', {'modal':'AlertModal', 'show':false}, {root:true})

    const status = error && error.response ? error.response.status : null
    const details = error && error.response && error.response.data
      ? (error.response.data.Message || error.response.data.message || '')
      : ''
    let title = 'Error'
    let text = 'Connection to server timed out, or uncaught error.'

    switch (status) {
    case 400:
      title = 'Error Code 400'
      text = 'Bad Request. Contact IT.'
      break
    case 401:
      title = 'Error Code 401'
      text = 'Unauthorized'
      dispatch("ActionLogout")
      break
    case 403:
      title = 'Error Code 403'
      text = 'Forbidden Access, you do not have permission.'
      break
    case 404:
      title = 'Error Code 404'
      text = 'Can not find the server.'
      break
    case 408:
      title = 'Error Code 408'
      text = 'Connection to server timed out'
      break
    case 500:
      title = 'Error Code 500'
      text = 'Internal Server Error. Contact IT.'
      break
    default:
      break
    }

    if (Vue.prototype.$vs && typeof Vue.prototype.$vs.notify === 'function') {
      Vue.prototype.$vs.notify({
        color: 'danger',
        title,
        text: details ? `${text}\n\n${details}` : text
      })
    }
  },


  // ActionFetchTasks ({state, commit}, payload) { //OBSOLETE

      
  //   commit('SetTaskList', [])
  //   return new Promise((resolve, reject) => {
  //     axios.get(`tasks?workerid=${  payload[0].toString()  }&projectid=${  payload[1].toString()}`)
  //       .then(response => {
  //         commit('SetTaskList', response.data)
  //       })
  //       .catch(error => {
  //         console.log(error)

  //       })
  //   })
  // },

  ActionFetchTask({state, commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`tasks/task?taskId=${payload}`)
        .then(response => {
          console.log('task', response.data)
          commit('SetTask', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  ActionFetchMyTaskList ({state, commit}, payload) {
     
    return new Promise((resolve, reject) => {
      axios.get('tasks/mine')
        .then(response => {
          commit('SetTaskList', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  ActionFetchMyTaskListV2 ({state, commit}, payload) {
     
    return new Promise((resolve, reject) => {
      axios.get('tasks/v2')
        .then(response => {
          commit('SetMyTaskList', response.data.tasks)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  ActionFetchAllTaskList ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('tasks/v2/all')
        .then(response => {
          commit('SetAllTaskList', response.data.tasks)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  ActionCreateNewTask({ state, commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.post('tasks/v2', payload)
        .then(response => {
          dispatch('ActionFetchMyTaskListV2')
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },


  ActionUpdateTaskPriority ({ dispatch }, { sowLineItemId, afterSowLineItemId }) {
    return axios.patch('tasks/v2/priority', { sowLineItemId, afterSowLineItemId: afterSowLineItemId != null ? afterSowLineItemId : null })
      .then(() => dispatch('ActionFetchMyTaskListV2'))
  },

  ActionMarkTaskComplete ({state, commit}, payload) {
     
    return new Promise((resolve, reject) => {
      axios.post('tasks/v2/complete', payload)
        .then(response => {
          commit('SetTaskComplete', payload)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  // ActionFetchTaskList ({state, commit}, payload) {
  //   return new Promise((resolve, reject) => {
  //     axios.get('tasks')
  //       .then(response => {
  //         console.log('ActionFetchTaskList - ', response)
  //         commit('SetTaskListAll', response.data)
  //         resolve(response)
  //       })
  //       .catch(error => {
  //         console.log(error)
  //         reject(error)
  //       })
  //   })
  // },
  

  // ActionPostTask ({state, commit}, payload) {
     
  //   return new Promise((resolve, reject) => {

  //     axios.post('tasks', payload)
  //       .then(response => {
           
  //         commit('SetNewTask', response.data)
          
  //         resolve(response)
  //       })
  //       .catch(error => {
  //         console.log(error.response)
  //         this.dispatch('ActionCheckError', error)
  //         reject(error)
  //       })

  //   })
  // },
  ActionPutTask ({state, commit}, payload) {
    return new Promise((resolve, reject) => {

      axios.put('tasks', payload)
        .then(response => {
          commit('SetUpdateTask', response.data)
          
          resolve(response)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionSetSimulation ({state, commit}, payload) {
    const effective = (payload.simulation != null && payload.simulation !== -1 && Number(payload.simulation) === Number(state.authWorkerID)) ? -1 : payload.simulation
    const sendPayload = { simulation: effective }
    return new Promise((resolve, reject) => {

      axios.post('account/simulation', sendPayload)
        .then(response => {
          console.log(`Set simulation to ${  effective}`)
          commit('SetSimulation', effective)
          commit('SetIsSimulation', effective != null && effective !== -1)
          this.dispatch('ActionFetchUserClient')
          this.dispatch('ActionFetchWorkerMessages')
          resolve(response)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })

    })
  },
  ActionGenerateSOWReport ({state, commit}, payload) {
    
    return new Promise((resolve, reject) => {
      if(payload.reportType == "chrome-pdf"){
        axios({
            url: `${process.env.VUE_APP_AXIOS_BASE_URL}reports/sow?SOWID=${payload.sowId}&type=chrome-pdf`,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');
        
            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'sow_report.pdf');
            document.body.appendChild(fileLink);
            fileLink.click();
            resolve(response)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
      }else{
        const url = `${process.env.VUE_APP_AXIOS_BASE_URL}reports/sow?SOWID=${payload.sowId}&type=html`
        axios.get(url)
        .then(response => {
          if(payload.reportType == "html"){
            // var a = window.open("about:blank", "Report")
            // a.document.write(response.data) 
            // a.document.close()
            // console.log('html resp', response)
            resolve(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
      }
    })
  },
  ActionGenerateSOWListReport ({state, commit}, payload) {
    
    return new Promise((resolve, reject) => {
      if(payload.reportType == "chrome-pdf"){
        axios({
            url: `${process.env.VUE_APP_AXIOS_BASE_URL}reports/sowlist?type=chrome-pdf&from=${payload.from}&to=${payload.to}`,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');
        
            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'sow_report.pdf');
            document.body.appendChild(fileLink);
            fileLink.click();
            resolve(response)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
      } else { }
    })
  },
  ActionGenerateReport ({state, commit}, payload) {
    
    return new Promise((resolve, reject) => {


      if(payload == "phantom-pdf"){
        axios({
            url: process.env.VUE_APP_AXIOS_BASE_URL + 'reports/employee-weekly-hours?type=' + payload,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');
        
            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'some_file.pdf');
            document.body.appendChild(fileLink);
            fileLink.click();
            resolve(response)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
      }else{

        axios.get('reports/employee-weekly-hours?type=' + payload)
        .then(response => {
          if(payload == "html"){
            var a = window.open("about:blank", "Report")
            a.document.write(response.data)
            a.document.close()
            resolve(response)
          }
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
      }
    })
  },

  ActionFetchSOWs ({state, commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get('sows', payload)
        .then(response => {
          commit('SetSOWList', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionSaveSOW ({state, commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.put(`sows`, payload)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },
  ActionDeleteSOW ({state, commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.delete(`sows?SOWID=${payload}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },
  ActionFetchSOWLineItems ({state, commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`sows/lineitems?SOWID=${payload}`)
        .then(response => {
          console.log('sow line items', response.data)
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },
  ActionFetchMySOWLineItems ({state, commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`sows/lineitems/assigned`)
        .then(response => {
          commit('SetMySOWLineItems', response.data)
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },
  ActionSaveLineItem ({state, commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      const normalizedTimeEstimate = payload.TimeEstimate === '' ? null : payload.TimeEstimate
      axios.put(`sows/lineitems`, {
        SOWLineItemID: payload.SOWLineItemID,
        Title: payload.Title,
        Description: payload.Description != null ? payload.Description : null,
        TimeEstimate: normalizedTimeEstimate,
        IsCompleted: payload.IsCompleted,
        AssignedTo: payload.AssignedTo,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },
  ActionCreateLineItem ({state, commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      const normalizedTimeEstimate = payload.TimeEstimate === '' ? null : payload.TimeEstimate
      axios.post(`sows/lineitems`, {
        SOWID: payload.SOWID,
        Title: payload.Title,
        Description: payload.Description != null ? payload.Description : null,
        TimeEstimate: normalizedTimeEstimate,
        IsCompleted: payload.IsCompleted,
        AssignedTo: payload.AssignedTo,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },
  ActionDeleteLineItem ({state, commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.delete(`sows/lineitems?SOWLineItemID=${payload}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },
  ActionMoveLineItem ({state, commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`sows/lineitems/move`, {
        SOWLineItemID: payload.SOWLineItemID,
        TargetSOWID: payload.TargetSOWID,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  
  ActionSaveDevOpsPAT({state, commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`account/pat`, { pat: payload })
        .then(response => {
          resolve(response.data)
          commit('SetDevOpsPAT', payload)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionSyncDevOps({state, commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`devops/release-definitions/sync`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  ActionFetchDevOpsReleaseDefs({state, commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`devops/release-definitions`)
        .then(response => {
          resolve(response.data)
          response.data.releaseDefinitions.forEach(x => {
            x.DisplayName = `${x.ProjectName} - ${x.ReleaseName}`
          })
          commit('SetDevOpsReleaseDefs', response.data.releaseDefinitions)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

  // CLIENTS
  ActionFetchClientInvoice ({state, commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`client/invoice?id=${payload}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.response)
          this.dispatch('ActionCheckError', error)
          reject(error)
        })
    })
  },

}

export default actions
